import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import * as Yup from "yup";
import {
  changeFormulaType,
  changeFormulaTypeFromGranularToRaw,
  customFormulaPostAction,
  getCustomHerbByFormulaId,
} from "../../actions/formulaAction";
import { clearUnfinalizedPrescription } from "../../actions/prescriptionAction";
import UndoIcon from "../../assets/images/undo-redo-icon.png";
import BreadCrumb from "../../components/Breadcrumb";
import FormulaList from "../../components/FormulaList";
import ItemSwitch from "../../components/ItemSwitch";
import SingleHerbList from "../../components/SingleHerbList";
import TotalPrescibed from "../../components/TotalPrescribed";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
import AddHerbPopup from "./AddHerbPopup";
import FormulaFinderPopup from "./FormulaFinderPopup";
import GranularToRawPopup from "./GranularToRawPopup";
import RawToGranularPopup from "./RawToGranularPopup";
import SuntenFormula from "../../components/SuntenFormula";
import { getPrescriptionFormSettings } from "../../actions/settingsActions";
import WarningPopup from "../CreatePrescription/WarningPopup";
import SuntenRemoveFormulaPopup from "./SuntenRemoveFormulaPopup";
const CustomFormulaBuilder = () => {
  const isRaw = useSelector((state) => state.formula.present.isRawType);
  const singleHerbList = useSelector(
    (state) => state.formula.present.singleHerbList
  );
  const [showAddHerb, setShowAddHerb] = useState(false);
  const [showFormulaFinderPopup, setShowFormulaFinderPopup] = useState(false);
  const [showRawToGranular, setShowRawToGranular] = useState(false);
  const [showGranularToRaw, setShowGranularToRaw] = useState(false);
  const [showSuntenRemovePopup, setShowSuntenRemovePopup] = useState(false);
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const pastFormulaState = useSelector((state) => state.formula.past);
  const futureFormulaState = useSelector((state) => state.formula.future);
  const overallTotal = useSelector((state) => state.formula.present.overall);
  const activeCustomFormula = useSelector(
    (state) => state.formula.present.activeCustomFormula
  );
  const prescriptionFormFields = useSelector(
    (state) => state.settings.prescriptionFormFields
  );
  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();
  const [isLocked, setIsLocked] = useState(false);
  const [days, setDays] = useState(1);
  const [rawGramPerDayBeforeConversion, setRawGramPerDayBeforeConversion] =
    useState(0);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const initialValues = {
    formulaName: "",
    dailyDosage: "",
    presciptionNote: "",
  };

  useEffect(() => {
    dispatch(changeFormulaType(true));
    dispatch(getPrescriptionFormSettings());
    setShowWarningPopup(true);
    return () => {
      dispatch(clearUnfinalizedPrescription());
      dispatch(UndoActionCreators.clearHistory());
    };
  }, [dispatch]);

  useEffect(() => {
    if (activeCustomFormula !== null) {
      initialValues.formulaName = activeCustomFormula.name;
      initialValues.dailyDosage = activeCustomFormula.daily_dosage
        ? activeCustomFormula.daily_dosage
        : "";
      initialValues.presciptionNote = activeCustomFormula.notes
        ? activeCustomFormula.notes
        : "";
      dispatch(
        changeFormulaType(
          activeCustomFormula.dosage_type === 0 ? true : false,
          0,
          () => {
            dispatch(
              getCustomHerbByFormulaId(
                activeCustomFormula.id,
                activeCustomFormula.name,
                null,
                parseInt(activeCustomFormula.total_dosage)
              )
            );
          }
        )
      );
    }
  }, [activeCustomFormula]);

  const handleChangeFormulaType = () => {
    if (formulas.length <= 0 && singleHerbList <= 0) {
      if (isRaw) {
        setShowGranularToRaw(true);
      } else {
        dispatch(changeFormulaType(!isRaw, 0));
      }
    } else {
      if (isRaw) {
        setShowRawToGranular(true);
      } else {
        if (formulas.some((x) => x.isSuntenFormula)) {
          setShowSuntenRemovePopup(true);
        } else {
          dispatch(changeFormulaTypeFromGranularToRaw(!isRaw, days));
        }
      }
    }
  };

  const validationSchema = Yup.object({
    formulaName: Yup.string().nullable().required("This field is required"),
    // dailyDosage: Yup.string().nullable().required("This field is required"),
    presciptionNote: Yup.string(),
  });

  const onSubmit = (values, { resetForm }) => {
    let herbList = [];
    formulas.forEach((x) => {
      x.formulaHerbs.forEach((y) => {
        herbList.push({
          HERB_ID: y.id,
          dosage_front: y.dosage,
        });
      });
    });
    singleHerbList.forEach((x) => {
      herbList.push({
        HERB_ID: x.id,
        dosage_front: x.dosage,
      });
    });
    const data = {
      name: values.formulaName,
      daily_dosage: values.dailyDosage,
      favorite: false,
      note: values.presciptionNote,
      total_dosage: overallTotal.totalDosage,
      dosage_type: isRaw ? 0 : 1,
      herbs: herbList,
    };
    if (activeCustomFormula !== null) {
      data.formula_id = activeCustomFormula.id;
    }
    var params = {
      action: "addeditCustomFormula",
      data: data,
      token: getUserDetail()?.token,
    };
    dispatch(
      customFormulaPostAction({ params: params }, () => {
        history.push("/app/formulas");
      })
    );
  };

  const getValueBeforeConversion = () => {
    let dosageBeforeConversion = 0;
    formulas.some((x) => {
      x.formulaHerbs.some((y) => {
        dosageBeforeConversion += (y.dosage * y.granularUnit) / y.rawRatio;
      });
    });

    singleHerbList.some((y) => {
      dosageBeforeConversion += (y.dosage * y.granularUnit) / y.rawRatio;
    });

    return dosageBeforeConversion;
  };

  return (
    <div className="builder-page">
      <BreadCrumb pageName="Your Custom Formula Builder" />
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Your Custom Formula Builder</h3>
          {showAddHerb && (
            <AddHerbPopup
              showUnavailableHerbs={prescriptionFormFields.showUnavailableHerbs}
              closePopup={() => setShowAddHerb(false)}
              formulaId={0}
              role={role}
            />
          )}
          {showRawToGranular && (
            <RawToGranularPopup
              isRawType={isRaw}
              closePopup={() => setShowRawToGranular(false)}
              setDays={setDays}
              setRawGram={() =>
                setRawGramPerDayBeforeConversion(getValueBeforeConversion())
              }
            />
          )}
          {showGranularToRaw && (
            <GranularToRawPopup
              isRawType={isRaw}
              setDays={setDays}
              closePopup={() => setShowGranularToRaw(false)}
              setRawGram={() =>
                setRawGramPerDayBeforeConversion(getValueBeforeConversion())
              }
            />
          )}

          {showSuntenRemovePopup && (
            <SuntenRemoveFormulaPopup
              isRawType={isRaw}
              days={days}
              closePopup={() => setShowSuntenRemovePopup(false)}
              setRawGram={() =>
                setRawGramPerDayBeforeConversion(getValueBeforeConversion())
              }
              formulas={formulas}
            />
          )}
          {showFormulaFinderPopup && (
            <FormulaFinderPopup
              closePopup={() => setShowFormulaFinderPopup(false)}
              isRawType={isRaw}
              fromCustomFormula={true}
            />
          )}
          {showWarningPopup && (
            <WarningPopup closePopup={() => setShowWarningPopup(false)} />
          )}
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, handleBlur }) => {
              return (
                <Form>
                  <div className="row mt-3">
                    <div className="col-sm-8">
                      <FormikControl
                        control="forminput"
                        type="text"
                        handleBlur={handleBlur}
                        label="* Name Your Custom Formula"
                        name="formulaName"
                        hasError={errors.formulaName && touched.formulaName}
                      />
                    </div>
                    <div className="col-sm-8">
                      <div className="row mt-3">
                        <div className="col-md-6 pl-5">
                          <ItemSwitch
                            itemOneText="Raw"
                            itemTwoText="Granular"
                            switchText="Convert"
                            switchValue={isRaw}
                            switchAction={handleChangeFormulaType}
                            showSwitchText={
                              singleHerbList?.length > 0 ||
                              formulas.some((x) => x.formulaHerbs.length > 0)
                            }
                          />
                        </div>
                        <div className="col-lg-6 d-flex align-items-end justify-content-end">
                          <button
                            className="undo-btn"
                            type="button"
                            disabled={pastFormulaState.length < 1}
                            onClick={() => {
                              dispatch(UndoActionCreators.undo());
                            }}
                          >
                            undo
                          </button>
                          <img src={UndoIcon} alt="undo-icon" />
                          <button
                            className="undo-btn"
                            disabled={futureFormulaState.length < 1}
                            type="button"
                            onClick={() => {
                              dispatch(UndoActionCreators.redo());
                            }}
                          >
                            redo
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" mt-2">
                    <p className="page-desc">FORMULA(S)</p>
                  </div>
                  <div
                    className={`row total-formula-section ${
                      isLocked ? "locked" : ""
                    }`}
                  >
                    <div className="col-md-12">
                      {/* {formulas.map((x) => (
                        <FormulaList
                          rawGramPerDayBeforeConversion={
                            rawGramPerDayBeforeConversion
                          }
                          isRawType={isRaw}
                          formula={x}
                          isOuterLocked={isLocked}
                          key={x.formulaId}
                        />
                      ))} */}
                      {formulas.map((x) =>
                        x.isSuntenFormula ? (
                          <SuntenFormula
                            rawGramPerDayBeforeConversion={
                              rawGramPerDayBeforeConversion
                            }
                            isRawType={isRaw}
                            formula={x}
                            key={x.formulaId}
                            isOuterLocked={isLocked}
                          />
                        ) : (
                          <FormulaList
                            showUnavailableHerbs={
                              prescriptionFormFields.showUnavailableHerbs
                            }
                            rawGramPerDayBeforeConversion={
                              rawGramPerDayBeforeConversion
                            }
                            isRawType={isRaw}
                            formula={x}
                            key={x.formulaId}
                            isOuterLocked={isLocked}
                          />
                        )
                      )}
                    </div>
                    <div className="col-sm-12 mt-2">
                      <button
                        type="button"
                        className="btn-orange"
                        onClick={() => setShowFormulaFinderPopup(true)}
                      >
                        Add Formula
                      </button>
                    </div>
                    <div className="col-md-12">
                      <SingleHerbList
                        rawGramPerDayBeforeConversion={
                          rawGramPerDayBeforeConversion
                        }
                        isRawType={isRaw}
                        isOuterLocked={isLocked}
                        singleHerbList={singleHerbList}
                      />
                    </div>
                    <div className="col-sm-12 mt-2">
                      <button
                        type="button"
                        className="btn-orange"
                        onClick={() => setShowAddHerb(true)}
                      >
                        Add Herb
                      </button>
                    </div>
                    <div className="col-md-12 mt-4">
                      <TotalPrescibed
                        isRawType={isRaw}
                        isLocked={isLocked}
                        setIsLocked={setIsLocked}
                        overallTotal={overallTotal}
                        multiplier={1}
                      />
                    </div>
                  </div>
                  <div className="row mt-2">
                    {/* <div className="col-sm-12">
                      <FormikControl
                        control="forminput"
                        type="number"
                        handleBlur={handleBlur}
                        label="* Enter daily Formula Dosage"
                        name="dailyDosage"
                        hasError={errors.dailyDosage && touched.dailyDosage}
                      />
                    </div> */}
                    <div className="col-sm-12 mt-3">
                      <FormikControl
                        handleBlur={handleBlur}
                        control="textarea"
                        label="Enter Formula Note Here"
                        name="presciptionNote"
                        rows="5"
                      />
                    </div>
                  </div>
                  <button className="btn-orange mt-2" type="submit">
                    Save Formula
                  </button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default CustomFormulaBuilder;
